import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';
import { coreInitiativesByIdDeleteAsyncSlice } from './delete';
import { coreInitiativesByIdGetAsyncSlice } from './get';
import { coreInitiativesByIdPatchAsyncSlice } from './patch';

export const coreInitiativesByIdReducers = combineReducers({
	delete: coreInitiativesByIdDeleteAsyncSlice.asyncReducers,
	get: coreInitiativesByIdGetAsyncSlice.asyncReducers,
	patch: coreInitiativesByIdPatchAsyncSlice.asyncReducers
});

export const coreInitiativesByIdWatchers = combineAllWatchers([
	coreInitiativesByIdDeleteAsyncSlice.asyncWatchers,
	coreInitiativesByIdGetAsyncSlice.asyncWatchers,
	coreInitiativesByIdPatchAsyncSlice.asyncWatchers
]);
